import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { getSaveEmailRoute } from "@api-routes/eirSalesFacade";
import { IEirSalesSaveEmailPayload } from "@modules/eirSalesFacade/interfaces/payloads/IEirSalesSaveEmailPayload";

export const postSaveEmail = (
    prospectReference: string,
    payload: IEirSalesSaveEmailPayload,
    options: IFetchOptions = {}
) =>
    fetcher<void>(getSaveEmailRoute(prospectReference), {
        method: "POST",
        body: payload,
        ...options,
    });
